// Ontdek (/(tabs)/ontdek) — web-port van app/(tabs)/ontdek.tsx met fictieve demo-feed.
// Structuur, typografie en kleuren volgen het origineel (theme.ts).
import React from 'react';
import Icon from '../../Icon';
import { C } from '../../theme';
import { PROPS, FEED, MARKTPULSE } from '../data';

const sh = { card: '0 6px 16px rgba(15,27,45,0.08)', soft: '0 2px 8px rgba(15,27,45,0.05)' };

// Tijd-gebaseerde begroeting — "Goedemorgen" / "Goedemiddag" / "Goedenavond".
function getGreetingEyebrow() {
  const now = new Date();
  const day = now.toLocaleDateString('nl-BE', { weekday: 'long' });
  const date = now.toLocaleDateString('nl-BE', { day: 'numeric', month: 'long' });
  return `${day.toUpperCase()} · ${date.toUpperCase()}`;
}
function greetingFor(name, isCouple, coupleName) {
  const h = new Date().getHours();
  const g = h < 6 ? 'Goedenacht' : h < 12 ? 'Goedemorgen' : h < 18 ? 'Goedemiddag' : 'Goedenavond';
  return `${g}, ${isCouple && coupleName ? coupleName : name}`;
}

function BellButton() {
  return (
    <div style={{
      width: 40, height: 40, borderRadius: 20, background: C.white,
      border: `1px solid ${C.line}`, display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', boxShadow: sh.soft,
    }}>
      <Icon name="bell" size={17} color={C.navy} />
      <span style={{ position: 'absolute', top: 9, right: 10, width: 7, height: 7, borderRadius: 4, background: C.gold, border: `1.5px solid ${C.white}` }} />
    </div>
  );
}

// Dagelijkse woonupdate — de stem van IMMO MATCH (WelcomeHero, fase: daily_pulse).
function WelcomeHero({ isCouple, name }) {
  return (
    <div style={{
      margin: '0 24px', borderRadius: 20, overflow: 'hidden', position: 'relative',
      background: `linear-gradient(160deg, ${C.navy}, ${C.navyDeep})`, padding: 20, boxShadow: sh.card,
    }}>
      <div style={{ color: C.gold, fontSize: 9.5, fontWeight: 800, letterSpacing: 1.6, marginBottom: 6 }}>
        IMMO MATCH · DAGELIJKSE WOONUPDATE
      </div>
      <div style={{ color: C.white, fontSize: 19, fontWeight: 700, letterSpacing: -0.2, lineHeight: '24px' }}>
        {isCouple ? 'Jullie feed is weer scherper dan gisteren' : 'Jouw feed is weer scherper dan gisteren'}
      </div>
      <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12.5, lineHeight: '18px', marginTop: 6 }}>
        {isCouple
          ? 'Op basis van jullie swipes en favorieten selecteerde ik vandaag enkel woningen die aan jullie beide profielen voldoen.'
          : 'Op basis van je swipes en favorieten selecteerde ik vandaag enkel woningen die écht bij jouw profiel passen.'}
      </div>
      <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
        {MARKTPULSE.map((b, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 5, height: 5, borderRadius: 3, background: C.gold, flexShrink: 0 }} />
            <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 12, fontWeight: 600 }}>{b.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function SectionHead({ eyebrow, title, seeAll }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', padding: '0 24px', marginBottom: 12, gap: 12 }}>
      <div style={{ flex: 1 }}>
        <div style={{ color: C.gold, fontSize: 11, letterSpacing: 2, fontWeight: 700 }}>{eyebrow}</div>
        <div style={{ color: C.navy, fontSize: 22, fontWeight: 700, letterSpacing: -0.3, marginTop: 2 }}>{title}</div>
      </div>
      {seeAll ? (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 4, background: C.white, borderRadius: 999,
          padding: '8px 12px', border: `1px solid ${C.line}`,
        }}>
          <span style={{ color: C.navy, fontSize: 13, fontWeight: 600 }}>{seeAll}</span>
          <Icon name="arrow-right" size={14} color={C.navy} />
        </div>
      ) : null}
    </div>
  );
}

function HeroCard({ p }) {
  return (
    <div style={{ height: 260, margin: '0 24px', borderRadius: 20, overflow: 'hidden', background: C.navy, position: 'relative', boxShadow: sh.card }}>
      <img src={p.img} alt={p.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(16,42,67,0) 30%, rgba(16,42,67,0.95) 100%)' }} />
      <div style={{ position: 'absolute', bottom: 18, left: 18, right: 18, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={{ color: C.gold, fontSize: 11, letterSpacing: 1.6, fontWeight: 800 }}>DE WONING VAN DE WEEK</div>
        <div style={{ color: C.white, fontSize: 22, fontWeight: 700, letterSpacing: -0.3 }}>{p.title}</div>
        <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15 }}>{p.city} · {p.price}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
          {(p.match_reasons || []).slice(0, 3).map((r) => (
            <span key={r} style={{
              background: 'rgba(255,255,255,0.18)', padding: '5px 10px', borderRadius: 999,
              border: '1px solid rgba(255,255,255,0.28)', color: C.white, fontSize: 11, fontWeight: 600, letterSpacing: 0.4,
            }}>{r}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

function MediumCard({ p }) {
  return (
    <div style={{ width: 260, flexShrink: 0, paddingBottom: 4 }}>
      <div style={{ width: '100%', height: 180, borderRadius: 14, overflow: 'hidden', background: C.navy, position: 'relative' }}>
        <img src={p.img} alt={p.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(16,42,67,0) 50%, rgba(16,42,67,0.65) 100%)' }} />
        <div style={{ position: 'absolute', bottom: 10, left: 12, right: 12 }}>
          <div style={{ color: C.white, fontSize: 14, fontWeight: 600 }}>{p.title}</div>
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginTop: 1 }}>{p.city}</div>
        </div>
      </div>
      <div style={{ paddingTop: 8, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <div style={{ color: C.gold, fontSize: 15, fontWeight: 600 }}>{p.price}</div>
        <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
          {(p.match_reasons || []).slice(0, 2).map((r) => (
            <span key={r} style={{ background: C.greenSoft, padding: '3px 8px', borderRadius: 999, color: C.navy, fontSize: 11, fontWeight: 600, letterSpacing: 0.4 }}>{r}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

function DropCard({ p }) {
  return (
    <div style={{ width: 240, flexShrink: 0, paddingBottom: 4 }}>
      <div style={{ width: '100%', height: 180, borderRadius: 14, overflow: 'hidden', background: C.navy, position: 'relative' }}>
        <img src={p.img} alt={p.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(16,42,67,0) 50%, rgba(16,42,67,0.65) 100%)' }} />
        <div style={{
          position: 'absolute', top: 10, left: 10, display: 'flex', alignItems: 'center', gap: 4,
          background: C.danger, padding: '4px 8px', borderRadius: 999,
        }}>
          <Icon name="trending-down" size={11} color={C.white} />
          <span style={{ color: C.white, fontSize: 11, fontWeight: 700, letterSpacing: 0.4 }}>-{p.drop_pct}%</span>
        </div>
        <div style={{ position: 'absolute', bottom: 10, left: 12, right: 12 }}>
          <div style={{ color: C.white, fontSize: 14, fontWeight: 600 }}>{p.title}</div>
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginTop: 1 }}>{p.city}</div>
        </div>
      </div>
      <div style={{ paddingTop: 8, display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{ color: C.gold, fontSize: 15, fontWeight: 600 }}>{p.priceDropped}</span>
        <span style={{ color: C.inkFaint, fontSize: 13, textDecoration: 'line-through' }}>{p.price}</span>
      </div>
    </div>
  );
}

function TeaserCard({ eyebrow, title, subtitle, cta, icon, variant, meta }) {
  const navy = variant === 'navy' || variant === 'premium';
  return (
    <div style={{
      margin: '0 24px', borderRadius: 16, padding: 16, position: 'relative', overflow: 'hidden',
      background: navy ? `linear-gradient(150deg, ${C.navy}, ${C.navyDeep})` : C.white,
      border: `1px solid ${variant === 'premium' ? 'rgba(196,138,58,0.6)' : navy ? 'rgba(196,138,58,0.25)' : C.line}`,
      boxShadow: sh.soft,
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{
          width: 42, height: 42, borderRadius: 21, flexShrink: 0,
          background: 'rgba(196,138,58,0.16)', border: '1px solid rgba(196,138,58,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon name={icon} size={17} color={C.gold} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: C.gold, fontSize: 10.5, fontWeight: 800, letterSpacing: 1.6 }}>{eyebrow}</span>
            {meta ? (
              <span style={{ background: C.gold, borderRadius: 999, padding: '2px 8px', color: C.navy, fontSize: 9, fontWeight: 800, letterSpacing: 0.8 }}>{meta}</span>
            ) : null}
          </div>
          <div style={{ color: navy ? C.white : C.navy, fontSize: 16, fontWeight: 700, marginTop: 3, letterSpacing: -0.2 }}>{title}</div>
          <div style={{ color: navy ? 'rgba(255,255,255,0.78)' : C.inkMuted, fontSize: 12.5, lineHeight: '18px', marginTop: 3 }}>{subtitle}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 10 }}>
            <span style={{ color: C.gold, fontSize: 13, fontWeight: 700 }}>{cta}</span>
            <Icon name="arrow-right" size={13} color={C.gold} />
          </div>
        </div>
      </div>
    </div>
  );
}

function LockedRow({ icon, title, desc, condition, color }) {
  return (
    <div style={{
      display: 'flex', gap: 12, alignItems: 'center', background: C.white, borderRadius: 14,
      padding: 12, border: `1.5px dashed ${C.line}`,
    }}>
      <div style={{ width: 40, height: 40, borderRadius: 20, background: C.bgSoft, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon name={icon} size={16} color={C.inkFaint} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ color: C.navy, fontSize: 13.5, fontWeight: 600 }}>{title}</span>
          <Icon name="lock" size={11} color={C.inkFaint} />
        </div>
        <div style={{ color: C.inkMuted, fontSize: 11.5, lineHeight: '16px', marginTop: 2 }}>{desc}</div>
        <div style={{ marginTop: 6, height: 4, borderRadius: 2, background: C.bgSoftDark }}>
          <div style={{ height: 4, borderRadius: 2, background: color, width: `${Math.round(condition.progress * 100)}%` }} />
        </div>
        <div style={{ color: C.inkFaint, fontSize: 10, fontWeight: 600, marginTop: 3 }}>{condition.label}</div>
      </div>
    </div>
  );
}

export default function OntdekApp({ mode }) {
  const feed = FEED[mode] || FEED.solo;
  const isCouple = feed.isCouple;
  const topmatch = PROPS[feed.topmatch];
  const highlights = feed.highlights.map((k) => PROPS[k]);
  const kansen = feed.kansen.map((k) => ({ ...PROPS[k.id], drop_pct: k.drop_pct }));

  return (
    <div data-testid="ontdek-screen" style={{ background: C.bgSoft, minHeight: '100%', paddingBottom: 80 }}>
      {/* Header — persoonlijke begroeting + profiel/meldingen */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '46px 24px 12px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ color: C.gold, fontSize: 9, letterSpacing: 1.6, fontWeight: 800, marginBottom: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getGreetingEyebrow()}</div>
          <div style={{ color: C.navy, fontSize: 21, fontWeight: 700, letterSpacing: -0.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {greetingFor(feed.firstName, isCouple, feed.coupleName)}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ width: 40, height: 40, borderRadius: 20, background: C.navy, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: C.white, fontSize: 17, fontWeight: 600 }}>{feed.firstName.slice(0, 1).toUpperCase()}</span>
          </div>
          <span style={{ color: C.inkFaint, marginTop: 3, fontSize: 8.5, letterSpacing: 1.1, fontWeight: 700 }}>PROFIEL</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: 8 }}>
          <BellButton />
          <span style={{ color: C.inkFaint, marginTop: 3, fontSize: 8.5, letterSpacing: 1.1, fontWeight: 700 }}>MELDINGEN</span>
        </div>
      </div>

      {/* 1. Dagelijkse woonupdate */}
      <WelcomeHero isCouple={isCouple} name={feed.firstName} />

      {/* 2. Marktpuls vandaag */}
      <div style={{ margin: '16px 24px 0', background: C.white, borderRadius: 14, padding: 14, border: `1px solid ${C.line}`, boxShadow: sh.soft }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
          <Icon name="trending-up" size={12} color={C.gold} />
          <span style={{ color: C.gold, fontSize: 10.5, fontWeight: 800, letterSpacing: 1.6 }}>MARKTPULS VANDAAG</span>
        </div>
        {MARKTPULSE.map((m, i) => (
          <div key={i} style={{ padding: '8px 0', borderTop: i ? '1px solid #F0EBE3' : 'none' }}>
            <div style={{ color: C.navy, fontSize: 13, fontWeight: 700 }}>{m.title}</div>
            <div style={{ color: C.inkMuted, fontSize: 11.5, marginTop: 1, lineHeight: '16px' }}>{m.body}</div>
          </div>
        ))}
      </div>

      {/* 3. Markt & nieuws CTA */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 14, overflow: 'hidden',
        border: '1px solid rgba(196,138,58,0.32)', margin: '12px 16px 4px',
        background: 'linear-gradient(135deg, #F1EBDF, #F7F2E4)',
      }}>
        <div style={{ width: 42, height: 42, borderRadius: 21, background: 'rgba(196,138,58,0.16)', border: '1px solid rgba(196,138,58,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon name="book-open" size={18} color={C.gold} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ color: C.gold, fontSize: 10.5, fontWeight: 800, letterSpacing: 1.6 }}>MARKT & NIEUWS</div>
          <div style={{ color: C.navy, fontSize: 14.5, fontWeight: 800, marginTop: 2, letterSpacing: -0.2 }}>Rente · leningen · registratie · EPC</div>
          <div style={{ color: C.inkMuted, fontSize: 12, marginTop: 3, lineHeight: '16.5px' }}>Alles wat je moet weten om onderbouwd te beslissen.</div>
        </div>
        <Icon name="arrow-right" size={18} color={C.navy} />
      </div>

      {/* 4. Jouw beste woningmatches */}
      <div style={{ marginTop: 24 }}>
        <SectionHead
          eyebrow={isCouple ? 'JULLIE BESTE MATCHES' : 'JOUW BESTE MATCHES'}
          title={isCouple ? 'Woningen die bij jullie beiden passen' : 'Woningen die écht bij jou passen'}
          seeAll="Swipe"
        />
        <HeroCard p={topmatch} />
        <div style={{ display: 'flex', gap: 12, overflowX: 'auto', padding: '12px 24px 4px' }}>
          {highlights.map((p) => <MediumCard key={p.id} p={p} />)}
        </div>
      </div>

      {/* 4b. In prijs verlaagd */}
      {kansen.length > 0 ? (
        <div style={{ marginTop: 24 }}>
          <SectionHead eyebrow="KANSEN VANDAAG" title="Nu in prijs verlaagd" seeAll="Alle" />
          <div style={{ display: 'flex', gap: 12, overflowX: 'auto', padding: '4px 24px' }}>
            {kansen.map((p) => <DropCard key={p.id} p={p} />)}
          </div>
        </div>
      ) : null}

      {/* 5. Woonreis teaser */}
      <div style={{ marginTop: 20 }}>
        <TeaserCard
          eyebrow={isCouple ? 'JULLIE WOONREIS' : 'MIJN WOONREIS'}
          title={isCouple ? 'Waar staan jullie in de zoektocht?' : 'Waar sta je in jouw zoektocht?'}
          subtitle={isCouple
            ? 'Volg de 7 fases van jullie woonreis en vink samen de stappen af naarmate jullie vorderen.'
            : 'Volg de 7 fases van jouw woonreis en vink de concrete stappen af naarmate je vordert.'}
          cta={isCouple ? 'Bekijk onze woonreis' : 'Bekijk mijn woonreis'}
          icon="map"
          variant="gold"
        />
      </div>

      {/* 7. Roadmap teaser */}
      <div style={{ marginTop: 12 }}>
        <TeaserCard
          eyebrow="ROADMAP"
          title="Wat komt eraan in IMMO MATCH"
          subtitle="Volg als eerste welke nieuwe Wooncoach-functies binnenkort worden gelanceerd en hoe ze je woonreis slimmer maken."
          cta="Bekijk de roadmap"
          icon="sunrise"
          variant="navy"
        />
      </div>

      {/* 7.5. Wat er nog voor jou opengaat */}
      <div style={{ margin: '20px 24px 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ color: C.gold, fontSize: 11, letterSpacing: 2, fontWeight: 700 }}>WAT ER NOG VOOR JOU OPENGAAT</div>
        <LockedRow icon="pie-chart" title="Woonbudget" desc="Bereken hoeveel je comfortabel kunt huren of kopen." color={C.gold} condition={{ label: '0 van 3 favorieten opgeslagen', progress: 0 }} />
        <LockedRow icon="camera" title="Wooninspiratie" desc="Bewaar stijlen en ruimtes die jouw toekomstige thuis vormgeven." color="#E75480" condition={{ label: 'Swipe één woning naar "Ja" (0/1)', progress: 0 }} />
        <LockedRow icon="check-square" title="Woonchecklist" desc="Persoonlijke checklist voor jouw volledige woontraject." color="#4B7BEC" condition={{ label: 'Voltooi één bezoek (0/1)', progress: 0 }} />
      </div>

      {/* 8. Premium teaser */}
      <div style={{ marginTop: 20 }}>
        <TeaserCard
          eyebrow="IMMO MATCH PREMIUM"
          title={isCouple ? 'Activeer jullie Wooncoach' : 'Activeer jouw Wooncoach'}
          subtitle={isCouple
            ? 'Ontgrendel route-analyse, woonbudget, AI-inspiratie, topmatches en persoonlijke begeleiding tijdens jullie volledige woontraject.'
            : 'Ontgrendel route-analyse, woonbudget, AI-inspiratie, topmatches en persoonlijke begeleiding tijdens je volledige woontraject.'}
          cta="Bekijk Premium"
          icon="award"
          variant="premium"
          meta="7 DAGEN GRATIS"
        />
      </div>
    </div>
  );
}
